module.exports = __webpack_public_path__ + "static/media/ic_airquality.23d41f48.png";